import React, { useEffect, useState } from "react";

import { HeroTextOnly } from '../../components';
import { NumbersRowSingle } from '../../components';
import { NumbersWrap } from '../../components';
import { NumberCell } from '../../components';
import { Banner } from '../../components';
import { Loader } from '../../components';
import { CircleFollow } from '../../components';
import { ArticleProducts } from '../../components';
import { PartnershipRow } from '../../components';
import { ClientsRow } from '../../components';
import {FeaturedCarousel} from '../../components'
import { BaseUrl } from "../../config";

const InvestorsContainer = () => {

  const [listClients, setListClients] = useState([]);
  const [featuredData, setFeaturedData] = useState([])
  const heroImg = require('../../assets/company/hero-studio-alto_2880x2160.jpg');
  const numImgSmall = require('../../assets/investors/team_img.png');
  const listPartners = [
    require('../../assets/homepage-partnership/VR_AR_association.png'),
    require('../../assets/homepage-partnership/khronos_bb.png'),
    require('../../assets/homepage-partnership/Retail_institute.png'),
    require('../../assets/homepage-partnership/assolombarda.png')
  ]
  const arrayLoad = [
    heroImg,
    numImgSmall,
    ...listPartners
  ]


  useEffect(() => {
    document.title = "Invest in Invrsion"
    fetch(`${BaseUrl}/page?key=invrsion&slug=home`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      
      setListClients(res.data.company.clients);
      
    })

    fetch(`${BaseUrl}/page?key=invrsion&slug=press-releases&page=press-releases`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      setFeaturedData(json.data.index_news.list_news);
    })
    
  }, [])
  return (
    <React.Fragment>
      
        <section className="company">
          <HeroTextOnly 
            title="Investor relations" 
            paragraph="See how Invrsion has laid the foundation for a new era of technology and business."
            extraParagraph="Why invest in Invrsion?"
            bottomParagraph="Become a pioneer in shaping the successful future of retail and reaping the benefits. The current worlds of shopping and VR experiences need real and continuous improvement. Invest in our vision and join us on our mission. A mission to open the door to Full Reality, where you can not only make a profit but can also make a real difference."
            textBelow={true} 
            align="right"
            greyParagraph={true}
          />
          
          <NumbersWrap>
            <NumbersRowSingle
              extraMargin={true}
            >
              <NumberCell 
                isImage={false} 
                bigNumber="88" 
                size="B" 
                title="Estimated value" 
                text="given to the Virtual Reality market by 2025 (Mordor Intelligence)"
              />
              <NumberCell 
                isImage={false} 
                bigNumber="184" 
                size="B" 
                title="Dollar boost" 
                text="to global GDP from the use of VR and AR in the retail and consumer sector by 2030 (PwC)"
              />
            </NumbersRowSingle>
          </NumbersWrap>
          <CircleFollow />
          <ArticleProducts 
            align="align-right"
            introText="Explore the benefits from investing in us"
            title="Scalable vision"
            extraPadding={true}
            articleText="We are a company with the capability to cope and perform well under an increased and expanding workload and scope."
          />
          <ArticleProducts 
            align="align-left" 
            title="Patented technologies"
            articleText="We are a company with an exclusive right to our products and processes, while offering a new technical solution to real-world problems."
          />
          <ArticleProducts 
            align="align-right"
            title="Global benefits"
            classToAdd="line-end-trigger"
            articleText="We are a company invested in bettering VR. An ever-growing industry that has proven to be a key player in boosting the global GDP."
          />
          {
            featuredData.length > 0 &&
            <FeaturedCarousel featuredData={featuredData} titleSection="Press releases" route="press-releases"/>
          }
          {
            listClients.length > 0 &&
            <ClientsRow 
              title="Brands that are already onboard and trust in Invrsion’s solutions"
              arrayClients={listClients}/>
          }
          <PartnershipRow 
            arrayPartners={listPartners} 
            title="We’re active members of recognized, top-tier associations." 
          />
          <Banner 
            text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" 
          />
        </section>
        <Loader arrayLoad={arrayLoad} />
      
    </React.Fragment>
  );
};

export default InvestorsContainer;
